<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-3-operation-retrovirus">
<h1>Chapter 3 <br/>Operation Retrovirus</h1>
<div class="section level2" id="langley-virginia-four-years-ago">
<h2>Langley, Virginia: Four Years Ago</h2>
<p>Internal Memo</p>
<p style="text-indent:00em;">Central Intelligence Agency</p>
<p style="text-indent:00em;">Designation: Classified—Top Secret</p>
<p style="text-indent:00em;">To: Director Norman Miller</p>
<p style="text-indent:00em;">From: James Bowie</p>
<p style="text-indent:00em;">CC:</p>
<p style="text-indent:00em;">Subject: Field Trial Successful</p>
<br/>
<p style="text-indent:00em;">Mr. Director,</p>
<p>As you know, Agent Justin Booker was sent to infiltrate the extremist group Boko Haram nine months ago in Chad shortly after they declared allegiance to the Islamic State. After years of preparation, this field test was to trial the concept of infiltrative counterinsurgency. As planned, he’s worked his way up to a position of prominence and trust in a large terrorist cell based in the city of Maliari just over the border from Niger.</p>
<p>At 1203 local time yesterday, he reported a successful neutralization of the terrorist cell, consisting of twenty-three individuals. He exploded their convoy with prepositioned incendiaries while they were en route to conduct a raid on a nearby village. Local officials within the police and military have since confirmed that all twenty-three targets were killed and their bodies (at least what was left of them) were accounted for.</p>
<p>Given this remarkable success I recommend the following:</p>
<ol style="list-style-type: decimal">
<li><p>Agent Booker receive commendations for his accomplishment.</p></li>
<li><p>Operation Retrovirus be advanced to phase two consisting of full funding.</p></li>
<li><p>The recruitment of no fewer than twenty experienced agents to begin immediate training for worldwide deployment on infiltrative counterinsurgency assignments on pre-approved target organizations.</p></li>
</ol>
<p style="text-indent:00em;">Sincerely,</p>
<p style="text-indent:00em;">James Bowie, Special Projects Team Leader</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?3c224eb3